import clm from "country-locale-map"
import { Answer, NumberAnswerData, RadioAnswerData } from "./config/questions"

export const DEFAULT_DECIMAL_PLACES = 2

export const isNumberAnswer = (answer: Answer): answer is NumberAnswerData => {
  return answer.type === "number"
}
export const isRadioAnswer = (answer: Answer): answer is RadioAnswerData => {
  return answer.type === "radio"
}

export const findCountry = (hostname: string, pathname: string) => {
  const firstPathPart = pathname.split("/")[1] // f.e. /us/en_US/hvac-quiz
  const subDomain = hostname.split(".")[0] // f.e. us.belimo.com -> us
  const topLevelDomain = hostname.split(".").pop() ?? "com" // f.e. www.belimo.br -> br

  if (clm.getCountryByAlpha2(firstPathPart.toUpperCase())) return firstPathPart

  if (clm.getCountryByAlpha2(subDomain.toUpperCase())) return subDomain

  if (clm.getCountryByAlpha2(topLevelDomain.toUpperCase()))
    return topLevelDomain

  if (topLevelDomain === "com") return "us"

  return null
}
